import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@thd-olt-component/react-elements';
import { GlobalContext } from '@thd-olt-global/global-provider-component';
import ProductEntryComponent from '@thd-olt-pages/product-entry';
import { withHeaders } from '@thd-olt-global/thd-axios/withHeaders';
import LayoutManager from '@thd-olt-component/layout-manager';
import { environmentKey } from '../../constants/key-provider';
import withPageChange from '../../components/PageChange';
import Helpers from '../../helpers/Helpers';

class ProductEntryPage extends Component {
  static contextType = GlobalContext;

  render() {
    const {
      cookies = {},
      expConfiguration = {},
      localizationStatus,
      localStore,
      request = {}
    } = this.context;

    const { recsAndSearchDynamicAPIEnabled = 'false' } = expConfiguration;
    const recsAndSearchDynamicAPIEnabledBool = (recsAndSearchDynamicAPIEnabled === 'true');

    const { channel, env, segment } = request;
    const apiKey = environmentKey(env);

    // support opening PEPs in new tabs
    const linkType = channel === 'mobile'
      ? '_spa'
      : this.props.linkType;

    let { pathname } = this.props;
    const { path } = request;
    if (typeof window === 'undefined') {
      pathname = path;
    }
    const deliveryZip = Helpers.getDeliveryZip();

    return (
      <div className="grid--bg-gray">
        <Row className="isBound">
          <Col>
            <LayoutManager input={{ page: 'pep' }} name="Collage PEP Page">
              <LayoutManager.Group name="PEP Page">
                <ProductEntryComponent
                  {...this.props}
                  apiKey={apiKey}
                  channel={channel}
                  deliveryZip={deliveryZip}
                  env={env}
                  linkType={linkType}
                  localStore={localStore}
                  localizationStatus={localizationStatus}
                  pathname={pathname}
                  recsAndSearchDynamicAPIEnabled={recsAndSearchDynamicAPIEnabledBool}
                  segment={segment}
                />
              </LayoutManager.Group>
            </LayoutManager>
          </Col>
        </Row>
      </div>
    );
  }
}

ProductEntryPage.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.shape()),
  categories: PropTypes.arrayOf(PropTypes.shape()),
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  linkType: PropTypes.string.isRequired,
  nValue: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  product: PropTypes.shape(),
  push: PropTypes.func.isRequired,
  querystring: PropTypes.string,
  replace: PropTypes.func.isRequired,
  seeFullDetailsLinkType: PropTypes.string
};

ProductEntryPage.defaultProps = {
  badges: [],
  categories: [],
  nValue: '',
  product: {},
  querystring: '',
  seeFullDetailsLinkType: '_self'
};


const headers = [{
  name: 'x-thd-canaveral-assignment',
  contextKey: 'canaveralAssignment',
  test: /SearchNav\/v2\/pages\/search/,
  onResponse: (resp, header) => {
    if (typeof window !== 'undefined') {
      Helpers.setCookie(header.name, header.value, 30);
    }
  }
}, {
  name: 'llc-env',
  contextKey: 'llcEnv',
  test: /SearchNav\/v2\/pages\/search|productModel/,
  transformer: (value) => {
    if (/q2/.test(value)) {
      return 'q2';
    }
    return value;
  }
}, {
  name: 'tt_search',
  contextKey: 'ttSearch',
  test: /SearchNav\/v2\/pages\/search/
}];

export default withPageChange(
  withHeaders(headers)(ProductEntryPage)
);
